import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { UserRole } from '@/shared/domain/enums';
import { Branch, Company } from '@/shared/domain/models';
import {
  requestInterceptor,
  responseInterceptor,
  errorHandler,
} from '@/shared/infrastructure/adapters/interceptors';

type CurrentAccountSuccess =
  | {
      name: string;
      type: UserRole;
      company: Company;
      branch: Branch;
    }
  | any;

type CurrentAccountError = {
  error: string;
};

type CurrentAccount = CurrentAccountSuccess | CurrentAccountError;

const getCurrentAccount =
  (instance: AxiosInstance) => (): Promise<AxiosResponse<CurrentAccount>> => {
    return instance.get('/accesses/current');
  };

export const partner = () => {
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_GATEWAY}/partner`,
    headers: {
      Accept: `application/vnd.creditas.v1+json`,
      'Content-Type': 'application/json',
      'X-Tenant-Id': 'creditasbr',
    },
  });

  instance.interceptors.request.use(requestInterceptor, errorHandler);

  instance.interceptors.response.use(responseInterceptor, errorHandler);

  return {
    getCurrentAccount: getCurrentAccount(instance),
  };
};
